import { render } from "./RefStatDetails.vue?vue&type=template&id=5908b936"
import script from "./RefStatDetails.vue?vue&type=script&lang=js"
export * from "./RefStatDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__